import { c as _c } from "react/compiler-runtime";
import { usePianoProfileState } from '@/hooks/store/use-piano-profile-store';
import { cn } from '@/lib/utils';

/** The instrument in one line: `Gaveau Model 1 — 89XXX`. */
export const PianoIdentity = t0 => {
  const $ = _c(7);
  const {
    className
  } = t0;
  const {
    displayName,
    serialNumber
  } = usePianoProfileState();
  if (!displayName && !serialNumber) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("max-w-[32ch] truncate font-mono text-xs text-muted-foreground max-md:hidden", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = displayName && serialNumber ? " \u2014 " : null;
  let t3;
  if ($[2] !== displayName || $[3] !== serialNumber || $[4] !== t1 || $[5] !== t2) {
    t3 = <span className={t1}>{displayName}{t2}{serialNumber}</span>;
    $[2] = displayName;
    $[3] = serialNumber;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};